module.exports = __webpack_public_path__ + "static/media/login-24px.44d833cf.svg";